import React, { useEffect, useState ,useRef} from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";

const AdminLogIn = () => {
  let navigate = useNavigate();
  const closeRef= useRef(null);
  const { logIn ,error,setError,currentUser} = useAuth();
 
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });

  const onChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
     
      await logIn(credentials.email, credentials.password);

      navigate("/admin");
    } catch {
    }

    setCredentials({
      email: "",
      password: "",
    });

    
    
    
  };
  
  useEffect(() => {
   if(currentUser){
     closeRef.current.click()
     
   }
  
  },[currentUser])

  

  return (
    <>

<div className="modal fade" id="loginModal" tabIndex="-1" aria-labelledby="loginModalLabel" aria-hidden="true"   >
  <div className="modal-dialog modal-dialog-centered"  >
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="loginModalLabel">Log In</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeRef} onClick={()=>{setError('')}}></button>
      </div>
      <div className="modal-body">
                 <form onSubmit={handleSubmit} method="POST">
              <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                   Email
                   </label>
                  <input
                    type="text"
                    className="form-control"
                    id="email"
                    aria-describedby="emailHelp"
                    name="email"
                    value={credentials.email}
                    onChange={onChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    value={credentials.password}
                    onChange={onChange}
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary"
                  //  data-bs-dismiss={closeModal}
                >
                  Log In
                </button>
                {error !=='' &&<p style={{color:'red',margin:'0'}}>
            Invalid Email or Password
              </p>}
              </form>
      </div>
      
    </div>
  </div>
</div>
</>

   
  );
};

export default AdminLogIn;
